// extracted by mini-css-extract-plugin
export var attribution = "_ck-4";
export var authorName = "_ck-5";
export var quote = "_ck-3";
export var testimonial = "_ck-2";
export var trustedBy = "_ck-0";
export var trustedByLabel = "_ck-1";